import i18n from '@/plugins/i18n';

export const ingressOverviewHeader = () => [
  {
    key: 'service_elb_healthy_host_count',
    tileName: i18n.global.t('aws.healthyHostCount'),
    name: i18n.global.t('aws.healthyHostCount'),
    value: 'sum',
    tooltip: i18n.global.t('aws.healthyHostCountTooltipForConnection'),
  },
  {
    key: 'service_elb_unhealthy_host_count',
    tileName: i18n.global.t('aws.unhealthyHostCount'),
    name: i18n.global.t('aws.unhealthyHostCount'),
    value: 'sum',
    tooltip: i18n.global.t('aws.unhealthyHostCountTooltipForConnection'),
  },
  {
    key: 'service_elb_average_request_count',
    tileName: i18n.global.t('aws.avgNoOfRequests'),
    name: i18n.global.t('aws.avgNoOfRequests'),
    value: 'avg',
    tooltip: i18n.global.t('aws.avgRequestLatencyTooltipForConnection'),
  },
  {
    key: 'service_elb_average_response_time',
    tileName: i18n.global.t('aws.avgResponseTime'),
    name: i18n.global.t('aws.avgResponseTime'),
    value: 'avg',
    tooltip: i18n.global.t('aws.avgResponseTimeTooltipForConnection'),
  },
  {
    key: 'lambda_function_count',
    tileName: i18n.global.t('aws.totalInstance'),
    name: i18n.global.t('aws.totalInstance'),
    value: 'sum',
    tooltip: i18n.global.t('aws.totalInstancesTooltipForConnection'),
  },
  {
    key: 'service_elb_errors',
    tileName: i18n.global.t('aws.totalErrors'),
    name: i18n.global.t('aws.totalErrors'),
    value: 'sum',
    tooltip: i18n.global.t('aws.totalErrorsTooltipForConnection'),
  },
];

export const ingressOverviewTableHeader = () => [
  {
    key: 'subscriptionId',
    name: i18n.global.t('aws.connectionName'),
  },
];

export const ingressSubscriptionHeader = () => [
  {
    key: 'service_elb_healthy_host_count',
    tileName: i18n.global.t('aws.healthyHostCount'),
    name: i18n.global.t('aws.healthyHostCount'),
    value: 'sum',
    tooltip: i18n.global.t('aws.healthyHostCountTooltipForInstance'),
  },
  {
    key: 'service_elb_unhealthy_host_count',
    tileName: i18n.global.t('aws.unhealthyHostCount'),
    name: i18n.global.t('aws.unhealthyHostCount'),
    value: 'sum',
    tooltip: i18n.global.t('aws.unhealthyHostCountTooltipForInstance'),
  },
  {
    key: 'service_elb_total_rejected_requests',
    tileName: i18n.global.t('aws.totalRejectedRequests'),
    name: i18n.global.t('aws.totalRejectedRequests'),
    value: 'sum',
    tooltip: i18n.global.t('aws.totalRejectedRequestsTooltip'),
  },
];

export const tabs = [
  {
    key: 'ALB',
    label: i18n.global.t('aws.ALB'),
    disabled: false,
  },
  {
    key: 'NLB',
    label: i18n.global.t('aws.NLB'),
    disabled: false,
  },
  {
    key: 'CLB',
    label: i18n.global.t('aws.CLB'),
    disabled: false,
  },
];

export const tabMapper = {
  1: 'ALB',
  2: 'NLB',
  3: 'CLB',
};
export const SUBSCRIPTION_PAGE = 'subscriptionId';
export const MAX_SLICE = 5;
export const MIN_SLICE = 0;
export const SUBSCRIPTION_MAX_SLICE = 1;
